const videoSources = {
  COMPUTER: 'computer',
  DROPBOX: 'dropbox',
  GOOGLE_DRIVE: 'drive',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  FACEBOOK: 'facebook',
  MIXED: 'mixed', // only for BI purposes, batch edit
};

export const externalVideoSources = [
  videoSources.YOUTUBE,
  videoSources.VIMEO,
  videoSources.FACEBOOK,
];

export default videoSources;



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/constants/video-sources.js